import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { IMAGE_TYPE } from 'src/app/core/constants/common';

@Component({
  selector: 'app-choose-image-modal',
  templateUrl: './choose-image.component.html',
  styleUrls: ['./choose-image.component.scss']
})
export class ChooseImageModalComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ChooseImageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
    private dialog: MatDialog,
    private toastr: ToastrService,
    public message: Message,

  ) {
    dialogRef.disableClose = false;
  }
  readonly IMAGE_TYPE = IMAGE_TYPE;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('galleryInput', { static: false }) galleryInput!: ElementRef<HTMLInputElement>;
  @ViewChild('videoElement', { static: false }) videoElement!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvasElement', { static: false }) canvasElement!: ElementRef<HTMLCanvasElement>;
  selectedImage: File | null = null;
  isCameraActive = false;
  isCameraError = false;
  private stream: MediaStream | null = null;
  ngOnInit(): void {
  }
  openCamera(): void {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      this.startCamera();
    } else {
      this.isCameraError = true;
      this.fileInput.nativeElement.click(); // fallback nếu trình duyệt không hỗ trợ MediaDevices
    }
  }

  startCamera(): void {
    this.isCameraError = false;
    navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' } })
      .then(stream => {
        this.stream = stream;
        this.isCameraActive = true;
        setTimeout(() => {
          if (this.videoElement) {
            this.videoElement.nativeElement.srcObject = stream;
            this.videoElement.nativeElement.play();
          }
        });
      })
      .catch(() => {
        this.isCameraError = true;
        this.isCameraActive = false;
      });
  }

  stopCamera(): void {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }
    this.isCameraActive = false;
  }

  capturePhoto(): void {
    const video = this.videoElement.nativeElement;
    const canvas = this.canvasElement.nativeElement;
    if (!video || !canvas) return;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const base64String = canvas.toDataURL('image/jpeg', 0.9);
    this.stopCamera();
    const fileUpload = {
      name: 'webcam.jpg',
      imageBase64: base64String
    };
    this.dialogRef.close(fileUpload);
  }

  closeModal(): void {
    this.stopCamera();
    this.dialogRef.close();
  }

  openGallery(): void {
    this.galleryInput.nativeElement.click(); // mở thư viện
  }

  handleFile(event: Event): void {
    const target = event.target as HTMLInputElement;
    const file = target.files[0];
    if (!file) return;

    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    const maxSizeMB = 5;
  
    if (!allowedTypes.includes(file.type)) {
      this.toastr.error(this.message.getMessage('kyc.invalid_image_format'));
      target.value = '';
      return;
    }
  
    const fileSizeMB = file.size / (1024 * 1024);
    if (fileSizeMB > maxSizeMB) {
      this.toastr.error(this.message.getMessage('kyc.image_size_exceeded'));
      target.value = '';
      return;
    }
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result as string;
        const fileUpload = {
          name: file.name,
          imageBase64: base64String
        }
        this.dialogRef.close(fileUpload); 
      };
      reader.readAsDataURL(file);
    }
  }
  // closeModal() {
  //   this.dialogRef.close();
  // }
}
